export interface ClassOption {
  value: string;
  label: string;
}

export const CLASS_OPTIONS: ClassOption[] = [
  { value: '001', label: '第 001 类 化工原料' },
  { value: '002', label: '第 002 类 油漆涂料' },
  { value: '003', label: '第 003 类 化妆品' },
  { value: '004', label: '第 004 类 工业油脂' },
  { value: '005', label: '第 005 类 药剂制品' },
  { value: '006', label: '第 006 类 五金器具' },
  { value: '007', label: '第 007 类 机械机器' },
  { value: '008', label: '第 008 类 手工用具' },
  { value: '009', label: '第 009 类 电子电器' },
  { value: '010', label: '第 010 类 医疗器械' },
  { value: '011', label: '第 011 类 家用电器' },
  { value: '012', label: '第 012 类 车辆配件' },
  { value: '013', label: '第 013 类 烟花爆竹' },
  { value: '014', label: '第 014 类 珠宝手表' },
  { value: '015', label: '第 015 类 乐器乐辅' },
  { value: '016', label: '第 016 类 文具办公' },
  { value: '017', label: '第 017 类 橡塑制品' },
  { value: '018', label: '第 018 类 皮具箱包' },
  { value: '019', label: '第 019 类 建筑材料' },
  { value: '020', label: '第 020 类 家具工艺' },
  { value: '021', label: '第 021 类 厨具日用' },
  { value: '022', label: '第 022 类 缆绳帐篷' },
  { value: '023', label: '第 023 类 线纱丝纺' },
  { value: '024', label: '第 024 类 床上用品' },
  { value: '025', label: '第 025 类 服装鞋帽' },
  { value: '026', label: '第 026 类 花边纽扣' },
  { value: '027', label: '第 027 类 地毯席垫' },
  { value: '028', label: '第 028 类 运动器械' },
  { value: '029', label: '第 029 类 食品鱼肉' },
  { value: '030', label: '第 030 类 食品米面' },
  { value: '031', label: '第 031 类 生鲜农产' },
  { value: '032', label: '第 032 类 啤酒饮料' },
  { value: '033', label: '第 033 类 酒精饮料' },
  { value: '034', label: '第 034 类 烟草制品' },
  { value: '035', label: '第 035 类 广告管理' },
  { value: '036', label: '第 036 类 金融经纪' },
  { value: '037', label: '第 037 类 修理安装' },
  { value: '038', label: '第 038 类 广播通讯' },
  { value: '039', label: '第 039 类 运输旅游' },
  { value: '040', label: '第 040 类 加工服务' },
  { value: '041', label: '第 041 类 教育娱乐' },
  { value: '042', label: '第 042 类 法律科技' },
  { value: '043', label: '第 043 类 餐饮住宿' },
  { value: '044', label: '第 044 类 医疗美容' },
  { value: '045', label: '第 045 类 法律服务' },
];


export const CLASS_OPTIONS1: ClassOption[] = [
  { value: '01', label: '第 01 类 化工原料' },
  { value: '02', label: '第 02 类 油漆涂料' },
  { value: '03', label: '第 03 类 化妆品' },
  { value: '04', label: '第 04 类 工业油脂' },
  { value: '05', label: '第 05 类 药剂制品' },
  { value: '06', label: '第 06 类 五金器具' },
  { value: '07', label: '第 07 类 机械机器' },
  { value: '08', label: '第 08 类 手工用具' },
  { value: '09', label: '第 09 类 电子电器' },
  { value: '10', label: '第 10 类 医疗器械' },
  { value: '11', label: '第 11 类 家用电器' },
  { value: '12', label: '第 12 类 车辆配件' },
  { value: '13', label: '第 13 类 烟花爆竹' },
  { value: '14', label: '第 14 类 珠宝手表' },
  { value: '15', label: '第 15 类 乐器乐辅' },
  { value: '16', label: '第 16 类 文具办公' },
  { value: '17', label: '第 17 类 橡塑制品' },
  { value: '18', label: '第 18 类 皮具箱包' },
  { value: '19', label: '第 19 类 建筑材料' },
  { value: '20', label: '第 20 类 家具工艺' },
  { value: '21', label: '第 21 类 厨具日用' },
  { value: '22', label: '第 22 类 缆绳帐篷' },
  { value: '23', label: '第 23 类 线纱丝纺' },
  { value: '24', label: '第 24 类 床上用品' },
  { value: '25', label: '第 25 类 服装鞋帽' },
  { value: '26', label: '第 26 类 花边纽扣' },
  { value: '27', label: '第 27 类 地毯席垫' },
  { value: '28', label: '第 28 类 运动器械' },
  { value: '29', label: '第 29 类 食品鱼肉' },
  { value: '30', label: '第 30 类 食品米面' },
  { value: '31', label: '第 31 类 生鲜农产' },
  { value: '32', label: '第 32 类 啤酒饮料' },
  { value: '33', label: '第 33 类 酒精饮料' },
  { value: '34', label: '第 34 类 烟草制品' },
  { value: '35', label: '第 35 类 广告管理' },
  { value: '36', label: '第 36 类 金融经纪' },
  { value: '37', label: '第 37 类 修理安装' },
  { value: '38', label: '第 38 类 广播通讯' },
  { value: '39', label: '第 39 类 运输旅游' },
  { value: '40', label: '第 40 类 加工服务' },
  { value: '41', label: '第 41 类 教育娱乐' },
  { value: '42', label: '第 42 类 法律科技' },
  { value: '43', label: '第 43 类 餐饮住宿' },
  { value: '44', label: '第 44 类 医疗美容' },
  { value: '45', label: '第 45 类 法律服务' },
];

export default CLASS_OPTIONS;
